/* @flow */

import utils from './utils';
import { callLiferayEndpoint } from './index';
import type { Purchase } from 'types';

const find = async (): Promise<Purchase[]> => {
  const endpoint =
    '/protones-portlet.orderhistoryitems/find-order-history-item-for-worklist-item-by-user';
  // TODO: Fix `start` & `end`
  const response = await callLiferayEndpoint(endpoint, {
    start: 0,
    end: 99999,
  });
  return response.map(utils.toPurchase);
};

export default {
  find,
};
